import { render, staticRenderFns } from "./ModifierSheet.vue?vue&type=template&id=4404b58c&scoped=true&"
import script from "./ModifierSheet.vue?vue&type=script&lang=js&"
export * from "./ModifierSheet.vue?vue&type=script&lang=js&"
import style0 from "./ModifierSheet.vue?vue&type=style&index=0&id=4404b58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4404b58c",
  null
  
)

export default component.exports